import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

// ============================================================
// DAILY CHALLENGE HUB - Card Grid + Modal approach
// 4 game cards on the home page, each opens a modal with the game.
// All 4 available every day with fresh content.
// ============================================================

const getDayOfYear = () => {
  const now = new Date();
  const start = new Date(now.getFullYear(), 0, 0);
  return Math.floor((now - start) / (1000 * 60 * 60 * 24));
};

// ======================== QUIZ POOL ========================
const quizPool = [
  { questions: [
    { q: "What is 3/4 as a percentage?", opts: ["70%","75%","80%","85%"], a: 1 },
    { q: "Which word is a synonym for 'brave'?", opts: ["Timid","Courageous","Cautious","Gentle"], a: 1 },
    { q: "What comes next: 2, 6, 18, 54, ___?", opts: ["108","162","72","216"], a: 1 }
  ]},
  { questions: [
    { q: "Area of a rectangle: length 12cm, width 5cm?", opts: ["17 cm²","34 cm²","60 cm²","120 cm²"], a: 2 },
    { q: "Which word means 'to make smaller'?", opts: ["Expand","Diminish","Amplify","Elevate"], a: 1 },
    { q: "If all roses are flowers, which must be true?", opts: ["All roses fade","Some roses fade","Roses are flowers","No roses fade"], a: 2 }
  ]},
  { questions: [
    { q: "What is 15% of 200?", opts: ["15","20","25","30"], a: 3 },
    { q: "Correct spelling?", opts: ["Neccessary","Necessary","Necesary","Neccesary"], a: 1 },
    { q: "Which shape has exactly 5 sides?", opts: ["Hexagon","Octagon","Pentagon","Quadrilateral"], a: 2 }
  ]},
  { questions: [
    { q: "Next prime number after 13?", opts: ["14","15","17","19"], a: 2 },
    { q: "What does 'benevolent' mean?", opts: ["Harmful","Kind and generous","Strict","Mysterious"], a: 1 },
    { q: "120km in 2 hours — what speed?", opts: ["40 km/h","50 km/h","60 km/h","80 km/h"], a: 2 }
  ]},
  { questions: [
    { q: "Which fraction equals 0.625?", opts: ["3/8","5/8","5/6","3/5"], a: 1 },
    { q: "Opposite of 'transparent'?", opts: ["Clear","Opaque","Visible","Bright"], a: 1 },
    { q: "Pattern: A1, C3, E5, ___?", opts: ["F6","G7","H8","G6"], a: 1 }
  ]},
  { questions: [
    { q: "What is 7 × 8?", opts: ["54","56","58","64"], a: 1 },
    { q: "What does 'reluctant' mean?", opts: ["Eager","Unwilling","Happy","Confused"], a: 1 },
    { q: "How many degrees in a triangle?", opts: ["90°","180°","270°","360°"], a: 1 }
  ]},
  { questions: [
    { q: "Simplify: 12/16", opts: ["2/3","3/4","4/5","6/8"], a: 1 },
    { q: "Which is an adverb?", opts: ["Quick","Quickly","Quicker","Quickest"], a: 1 },
    { q: "Perimeter of a square with side 9cm?", opts: ["18cm","27cm","36cm","81cm"], a: 2 }
  ]},
  { questions: [
    { q: "What is 25% of 80?", opts: ["15","20","25","40"], a: 1 },
    { q: "Synonym for 'enormous'?", opts: ["Tiny","Vast","Narrow","Shallow"], a: 1 },
    { q: "Next: 1, 1, 2, 3, 5, ___?", opts: ["6","7","8","10"], a: 2 }
  ]},
  { questions: [
    { q: "How many faces does a cube have?", opts: ["4","6","8","12"], a: 1 },
    { q: "What does 'ambiguous' mean?", opts: ["Clear","Uncertain","Angry","Generous"], a: 1 },
    { q: "If a = 5, what is 3a + 2?", opts: ["13","15","17","20"], a: 2 }
  ]},
  { questions: [
    { q: "Convert 0.4 to a fraction:", opts: ["1/4","2/5","4/10","2/4"], a: 1 },
    { q: "Which sentence is correct?", opts: ["Their going home","They're going home","There going home","Theyre going home"], a: 1 },
    { q: "Angles in a quadrilateral total?", opts: ["180°","270°","360°","540°"], a: 2 }
  ]},
  { questions: [
    { q: "What is the square root of 144?", opts: ["10","11","12","14"], a: 2 },
    { q: "What does 'diligent' mean?", opts: ["Lazy","Hardworking","Confused","Angry"], a: 1 },
    { q: "Odd one out: 2, 5, 8, 12, 14?", opts: ["2","5","12","14"], a: 1 }
  ]},
  { questions: [
    { q: "What is 1000 ÷ 8?", opts: ["120","125","130","150"], a: 1 },
    { q: "Antonym of 'ancient'?", opts: ["Old","Modern","Historic","Classic"], a: 1 },
    { q: "Lines of symmetry in a hexagon?", opts: ["3","4","6","8"], a: 2 }
  ]},
  { questions: [
    { q: "Round 3,467 to nearest hundred:", opts: ["3,400","3,470","3,500","3,000"], a: 2 },
    { q: "What is a 'metaphor'?", opts: ["A type of poem","Comparison without like/as","A rhyming word","A long sentence"], a: 1 },
    { q: "Volume: 4cm × 3cm × 2cm?", opts: ["9 cm³","14 cm³","24 cm³","48 cm³"], a: 2 }
  ]},
  { questions: [
    { q: "What is 2³?", opts: ["6","8","9","16"], a: 1 },
    { q: "Which word has a prefix meaning 'not'?", opts: ["Redo","Unhappy","Preview","Subway"], a: 1 },
    { q: "Probability of rolling a 3 on a die?", opts: ["1/2","1/3","1/6","1/12"], a: 2 }
  ]},
  { questions: [
    { q: "What is 40% of 150?", opts: ["40","50","60","75"], a: 2 },
    { q: "What does 'vivid' mean?", opts: ["Dull","Bright and clear","Quiet","Slow"], a: 1 },
    { q: "Edges on a rectangular prism?", opts: ["6","8","10","12"], a: 3 }
  ]},
  { questions: [
    { q: "Simplify: 18/24", opts: ["2/3","3/4","4/6","6/8"], a: 0 },
    { q: "Which is a compound sentence?", opts: ["I ran fast.","I ran fast, and I won.","Running fast.","The fast runner."], a: 1 },
    { q: "Mean of 4, 8, 12?", opts: ["4","8","10","12"], a: 1 }
  ]},
  { questions: [
    { q: "What is 9²?", opts: ["18","72","81","99"], a: 2 },
    { q: "What does 'conceal' mean?", opts: ["Reveal","Hide","Build","Destroy"], a: 1 },
    { q: "Vertices in a triangle?", opts: ["2","3","4","5"], a: 1 }
  ]},
  { questions: [
    { q: "Convert 3/5 to a decimal:", opts: ["0.35","0.5","0.6","0.65"], a: 2 },
    { q: "Which word is an adjective?", opts: ["Run","Beautiful","Quickly","And"], a: 1 },
    { q: "LCM of 4 and 6?", opts: ["2","10","12","24"], a: 2 }
  ]},
  { questions: [
    { q: "20% off $45. Sale price?", opts: ["$25","$30","$36","$40"], a: 2 },
    { q: "What does 'persevere' mean?", opts: ["Give up","Keep trying","Run away","Forget"], a: 1 },
    { q: "Face North, turn 90° right. You face?", opts: ["South","East","West","North"], a: 1 }
  ]},
  { questions: [
    { q: "GCD of 12 and 18?", opts: ["2","3","6","9"], a: 2 },
    { q: "Which is a simile?", opts: ["The sun smiled","Brave as a lion","Time flies","Heart of gold"], a: 1 },
    { q: "How many cm in 2.5 metres?", opts: ["25","250","2500","25000"], a: 1 }
  ]},
  { questions: [
    { q: "What is 1/3 + 1/6?", opts: ["1/2","2/9","1/3","2/6"], a: 0 },
    { q: "What does 'abundant' mean?", opts: ["Scarce","Plentiful","Empty","Broken"], a: 1 },
    { q: "Angles on a straight line?", opts: ["90°","180°","270°","360°"], a: 1 }
  ]},
  { questions: [
    { q: "What is 3.5 × 4?", opts: ["12","13","14","15"], a: 2 },
    { q: "Which word has a suffix?", opts: ["Pre-game","Undo","Joyful","Bicycle"], a: 2 },
    { q: "Clock at 3:45 — angle between hands?", opts: ["90°","157.5°","172.5°","180°"], a: 1 }
  ]},
  { questions: [
    { q: "What is 5! (factorial)?", opts: ["25","60","100","120"], a: 3 },
    { q: "What does 'meticulous' mean?", opts: ["Careless","Very careful","Fast","Loud"], a: 1 },
    { q: "Lines of symmetry in a circle?", opts: ["1","4","8","Infinite"], a: 3 }
  ]},
  { questions: [
    { q: "7/20 as a percentage:", opts: ["7%","14%","35%","70%"], a: 2 },
    { q: "Correct plural?", opts: ["Childs","Childrens","Children","Childes"], a: 2 },
    { q: "Mode of: 3, 5, 5, 7, 9?", opts: ["3","5","7","9"], a: 1 }
  ]},
  { questions: [
    { q: "0.75 × 100?", opts: ["7.5","75","750","0.75"], a: 1 },
    { q: "What does 'eloquent' mean?", opts: ["Silent","Fluent and persuasive","Angry","Confused"], a: 1 },
    { q: "Interior angles of a pentagon?", opts: ["360°","480°","540°","720°"], a: 2 }
  ]},
  { questions: [
    { q: "Median of: 2, 4, 7, 9, 11?", opts: ["4","7","9","6.6"], a: 1 },
    { q: "Antonym of 'generous'?", opts: ["Kind","Stingy","Wealthy","Humble"], a: 1 },
    { q: "How many mL in 1.5 litres?", opts: ["15","150","1500","15000"], a: 2 }
  ]},
  { questions: [
    { q: "2/3 of 90?", opts: ["30","45","60","75"], a: 2 },
    { q: "Correct use of 'affect'?", opts: ["The affect was huge","It will affect your grade","She had a good affect","Affect the results showed"], a: 1 },
    { q: "Sides on a regular octagon?", opts: ["6","7","8","10"], a: 2 }
  ]},
  { questions: [
    { q: "11 × 12?", opts: ["121","132","142","144"], a: 1 },
    { q: "What does 'inevitable' mean?", opts: ["Avoidable","Certain to happen","Unlikely","Surprising"], a: 1 },
    { q: "Complementary angles add to?", opts: ["45°","90°","180°","360°"], a: 1 }
  ]},
  { questions: [
    { q: "Simplify ratio 15:25", opts: ["1:2","3:5","5:3","15:25"], a: 1 },
    { q: "Example of onomatopoeia?", opts: ["Bright","Buzz","Beautiful","Brave"], a: 1 },
    { q: "Grams in 2.3 kg?", opts: ["23","230","2300","23000"], a: 2 }
  ]},
  { questions: [
    { q: "Range of: 3, 7, 2, 9, 5?", opts: ["5","7","9","12"], a: 1 },
    { q: "What does 'resilient' mean?", opts: ["Fragile","Recovers quickly","Slow","Rigid"], a: 1 },
    { q: "Faces on a triangular prism?", opts: ["3","4","5","6"], a: 2 }
  ]}
];

// ======================== WORD POOL ========================
const wordPool = [
  { word: "Perseverance", def: "Continued effort despite difficulty", example: "Her perseverance helped her master long division.", hint: "Think: never giving up on a hard maths problem" },
  { word: "Hypothesis", def: "An educated guess or prediction", example: "The scientist formed a hypothesis before the experiment.", hint: "Think: what you predict will happen in science" },
  { word: "Elaborate", def: "To explain in more detail; complex", example: "Please elaborate on your answer with examples.", hint: "Think: adding more detail to a short answer" },
  { word: "Consequence", def: "A result or effect of an action", example: "One consequence of not studying is lower test scores.", hint: "Think: what happens because of something" },
  { word: "Ambiguous", def: "Having more than one possible meaning", example: "The ambiguous question confused many students.", hint: "Think: unclear, could mean different things" },
  { word: "Diligent", def: "Showing careful and persistent effort", example: "The diligent student reviewed her notes every evening.", hint: "Think: hardworking and thorough" },
  { word: "Inevitable", def: "Certain to happen; unavoidable", example: "Change is inevitable as we grow older.", hint: "Think: something you can't stop from happening" },
  { word: "Resilient", def: "Able to recover quickly from difficulties", example: "Resilient students learn from their mistakes.", hint: "Think: bouncing back after a setback" },
  { word: "Meticulous", def: "Showing great attention to detail", example: "She was meticulous in checking her calculations.", hint: "Think: very careful and precise" },
  { word: "Eloquent", def: "Fluent and persuasive in speaking or writing", example: "His eloquent essay won the writing competition.", hint: "Think: speaking or writing beautifully" },
  { word: "Abundant", def: "Existing in large quantities; plentiful", example: "The garden had an abundant supply of vegetables.", hint: "Think: more than enough" },
  { word: "Concise", def: "Giving information clearly in few words", example: "Keep your answers concise and to the point.", hint: "Think: short but complete" },
  { word: "Deduce", def: "To reach a conclusion by reasoning", example: "From the clues, she could deduce the answer.", hint: "Think: figuring something out logically" },
  { word: "Empathy", def: "The ability to understand others' feelings", example: "Showing empathy makes you a better friend.", hint: "Think: feeling what someone else feels" },
  { word: "Fluctuate", def: "To rise and fall irregularly", example: "Temperatures fluctuate between seasons.", hint: "Think: going up and down unpredictably" },
  { word: "Gregarious", def: "Fond of company; sociable", example: "The gregarious student loved group projects.", hint: "Think: someone who loves being around people" },
  { word: "Illuminate", def: "To light up; to make clear", example: "The teacher's explanation illuminated the concept.", hint: "Think: shining a light on something" },
  { word: "Justify", def: "To show or prove to be right", example: "You must justify your answer with evidence.", hint: "Think: explaining why your answer is correct" },
  { word: "Keen", def: "Eager and enthusiastic; sharp", example: "She has a keen interest in mathematics.", hint: "Think: really excited about something" },
  { word: "Legitimate", def: "Conforming to rules; genuine", example: "That is a legitimate reason for being absent.", hint: "Think: real and acceptable" },
  { word: "Monotonous", def: "Dull and lacking variety", example: "The monotonous lecture put students to sleep.", hint: "Think: boring and repetitive" },
  { word: "Negligible", def: "So small as to be meaningless", example: "The difference between the two scores was negligible.", hint: "Think: too tiny to matter" },
  { word: "Obscure", def: "Not clearly understood; hidden", example: "The meaning of the poem was obscure.", hint: "Think: hard to see or understand" },
  { word: "Plausible", def: "Seeming reasonable or probable", example: "Her explanation sounded plausible.", hint: "Think: believable and makes sense" },
  { word: "Reluctant", def: "Unwilling and hesitant", example: "He was reluctant to present in front of the class.", hint: "Think: not really wanting to do something" },
  { word: "Substantial", def: "Of considerable importance or size", example: "She made substantial progress in reading.", hint: "Think: big and significant" },
  { word: "Trivial", def: "Of little value or importance", example: "Don't waste time on trivial details.", hint: "Think: not important at all" },
  { word: "Unanimous", def: "Fully in agreement", example: "The decision was unanimous — everyone agreed.", hint: "Think: when every single person agrees" },
  { word: "Versatile", def: "Able to adapt to many functions", example: "A versatile student excels in multiple subjects.", hint: "Think: good at many different things" },
  { word: "Wary", def: "Feeling cautious about possible dangers", example: "Be wary of trick questions in the exam.", hint: "Think: careful and on guard" }
];

// ======================== BRAIN TEASER POOL ========================
const teaserPool = [
  { puzzle: "I have cities but no houses, forests but no trees, and water but no fish. What am I?", answer: "a map", hint: "Think about what shows all these things without actually having them..." },
  { puzzle: "What has keys but no locks, space but no room, and you can enter but can't go inside?", answer: "a keyboard", hint: "You use it every day with a computer..." },
  { puzzle: "If you have 3 apples and take away 2, how many do you have?", answer: "2", hint: "Read carefully — how many did YOU take?" },
  { puzzle: "A farmer has 17 sheep. All but 9 run away. How many are left?", answer: "9", hint: "'All but 9' means 9 stay..." },
  { puzzle: "What number do you get when you multiply all the numbers on a phone's number pad?", answer: "0", hint: "Think about ALL the numbers, including one special one..." },
  { puzzle: "How many times can you subtract 5 from 25?", answer: "once", hint: "After the first time, you're not subtracting from 25 anymore..." },
  { puzzle: "A bat and ball cost $1.10 together. The bat costs $1 more than the ball. How much is the ball?", answer: "5 cents", hint: "It's not 10 cents! If ball is 10c, bat would be $1.10..." },
  { puzzle: "What 5-letter word becomes shorter when you add 2 letters to it?", answer: "short", hint: "The answer is literally in the question..." },
  { puzzle: "I am an odd number. Take away a letter and I become even. What number am I?", answer: "seven", hint: "Think of number names, not digits..." },
  { puzzle: "How can you make 7 even without adding, subtracting, multiplying, or dividing?", answer: "remove the s", hint: "Think about the word, not the number..." },
  { puzzle: "What comes once in a minute, twice in a moment, but never in a thousand years?", answer: "the letter m", hint: "Count the letters, not the time..." },
  { puzzle: "If you rearrange 'CIFAIPC', you get the name of a(n) ___?", answer: "ocean", hint: "Think geography — PACIFIC..." },
  { puzzle: "Two fathers and two sons go fishing. They each catch one fish but bring home only 3. How?", answer: "grandfather father son", hint: "A father can also be a son..." },
  { puzzle: "What has a head and a tail but no body?", answer: "a coin", hint: "You might flip it to make a decision..." },
  { puzzle: "If 5 machines take 5 minutes to make 5 widgets, how long for 100 machines to make 100?", answer: "5 minutes", hint: "Each machine makes 1 widget in 5 minutes..." },
  { puzzle: "What gets wetter the more it dries?", answer: "a towel", hint: "Think about what you use after a shower..." },
  { puzzle: "You see a boat filled with people but not a single person on board. How?", answer: "everyone is married", hint: "Think about the word 'single' differently..." },
  { puzzle: "What can travel around the world while staying in a corner?", answer: "a stamp", hint: "Think about what goes on an envelope..." },
  { puzzle: "The more you take, the more you leave behind. What am I?", answer: "footsteps", hint: "Think about walking..." },
  { puzzle: "What has 4 fingers and a thumb but isn't alive?", answer: "a glove", hint: "You wear it when it's cold..." },
  { puzzle: "Forward I am heavy, backward I am not. What am I?", answer: "ton", hint: "Think about the word itself, spelled backward..." },
  { puzzle: "What begins with T, ends with T, and has T in it?", answer: "a teapot", hint: "It holds a hot drink and has tea inside..." },
  { puzzle: "What disappears as soon as you say its name?", answer: "silence", hint: "The moment you speak, it's gone..." },
  { puzzle: "I have branches but no fruit, trunk, or leaves. What am I?", answer: "a bank", hint: "Think about where you keep money..." },
  { puzzle: "What can you hold in your right hand but never in your left?", answer: "your left elbow", hint: "Try it right now..." },
  { puzzle: "What has many teeth but cannot bite?", answer: "a comb", hint: "You use it on your hair..." },
  { puzzle: "What runs but never walks, has a mouth but never talks?", answer: "a river", hint: "Think about nature and water..." },
  { puzzle: "What has one eye but cannot see?", answer: "a needle", hint: "You use it for sewing..." },
  { puzzle: "What building has the most stories?", answer: "a library", hint: "Think about the double meaning of 'stories'..." },
  { puzzle: "What goes up but never comes down?", answer: "your age", hint: "Think about something that only increases..." }
];

// ======================== WORDLE POOL ========================
const wordlePool = [
  "BRAIN","THINK","SOLVE","LEARN","STUDY","SMART","LOGIC","PROOF","GRAPH","ANGLE",
  "RATIO","PRIME","EQUAL","DIGIT","SHAPE","SCALE","TOTAL","VALUE","POWER","RANGE",
  "THEME","DRAFT","ESSAY","QUOTE","VERSE","MORAL","GENRE","PROSE","NOVEL","FABLE",
  "SKILL","FOCUS","GRASP","QUEST","TRACE","SWIFT","BLAZE","CRISP","GLEAM","VIVID",
  "ADEPT","LUCID","MERIT","VIGOR","SCOPE","YIELD","UNITY","EXACT","BRIEF","RAPID"
];

// Common 5-letter English words for validation
const validWords = new Set([
  // Common words kids might guess
  "ABOUT","ABOVE","ABUSE","ACTOR","ACUTE","ADMIT","ADOPT","ADULT","AFTER","AGAIN",
  "AGENT","AGREE","AHEAD","ALARM","ALBUM","ALERT","ALIEN","ALIGN","ALIVE","ALLEY",
  "ALLOW","ALONE","ALONG","ALTER","AMONG","ANGEL","ANGER","ANGLE","ANGRY","APART",
  "APPLE","APPLY","ARENA","ARGUE","ARISE","ARMOR","ARRAY","ASIDE","ASSET","AVOID",
  "AWARD","AWARE","BADLY","BASIC","BASIS","BEACH","BEGIN","BEING","BELOW","BENCH",
  "BIRTH","BLACK","BLADE","BLAME","BLAND","BLANK","BLAST","BLAZE","BLEED","BLEND",
  "BLESS","BLIND","BLOCK","BLOOD","BLOOM","BLOWN","BOARD","BOAST","BONUS","BOUND",
  "BRAIN","BRAND","BRAVE","BREAD","BREAK","BREED","BRICK","BRIEF","BRING","BROAD",
  "BROKE","BROWN","BRUSH","BUILD","BUNCH","BURST","BUYER","CABIN","CARRY","CATCH",
  "CAUSE","CHAIN","CHAIR","CHARM","CHART","CHASE","CHEAP","CHECK","CHEEK","CHEER",
  "CHESS","CHEST","CHIEF","CHILD","CHINA","CHOSE","CIVIL","CLAIM","CLASS","CLEAN",
  "CLEAR","CLIMB","CLING","CLOCK","CLONE","CLOSE","CLOTH","CLOUD","COACH","COAST",
  "COLOR","COMET","CORAL","COULD","COUNT","COURT","COVER","CRACK","CRAFT","CRANE",
  "CRASH","CRAZY","CREAM","CRIME","CRISP","CROSS","CROWD","CROWN","CRUEL","CRUSH",
  "CURVE","CYCLE","DAILY","DANCE","DEATH","DEBUT","DELAY","DEPTH","DERBY","DEVIL",
  "DIGIT","DIRTY","DOUBT","DOUGH","DRAFT","DRAIN","DRAMA","DRANK","DRAWN","DREAM",
  "DRESS","DRIED","DRIFT","DRILL","DRINK","DRIVE","DROIT","DROVE","DYING","EAGER",
  "EARLY","EARTH","EIGHT","ELECT","ELITE","EMPTY","ENEMY","ENJOY","ENTER","EQUAL",
  "ERROR","ESSAY","EVENT","EVERY","EXACT","EXAMS","EXIST","EXTRA","FABLE","FAITH",
  "FALSE","FANCY","FATAL","FAULT","FEAST","FENCE","FEVER","FIBER","FIELD","FIFTH",
  "FIFTY","FIGHT","FINAL","FIRST","FIXED","FLAME","FLASH","FLEET","FLESH","FLOAT",
  "FLOOD","FLOOR","FLOUR","FLUID","FLUSH","FLUTE","FOCUS","FORCE","FORGE","FORTH",
  "FORUM","FOUND","FRAME","FRANK","FRAUD","FRESH","FRONT","FROST","FRUIT","FULLY",
  "GENRE","GHOST","GIANT","GIVEN","GLASS","GLEAM","GLOBE","GLOOM","GLORY","GOING",
  "GRACE","GRADE","GRAIN","GRAND","GRANT","GRAPH","GRASP","GRASS","GRAVE","GREAT",
  "GREEN","GREET","GRIEF","GRILL","GRIND","GROSS","GROUP","GROWN","GUARD","GUESS",
  "GUEST","GUIDE","GUILT","HABIT","HAPPY","HARSH","HAVEN","HEART","HEAVY","HENCE",
  "HORSE","HOTEL","HOUSE","HUMAN","HUMOR","HURRY","IDEAL","IMAGE","IMPLY","INDEX",
  "INNER","INPUT","ISSUE","IVORY","JEWEL","JOINT","JUDGE","JUICE","KNOCK","KNOWN",
  "LABEL","LARGE","LASER","LATER","LAUGH","LAYER","LEARN","LEASE","LEAST","LEAVE",
  "LEGAL","LEVEL","LIGHT","LIMIT","LINEN","LIVER","LOGIC","LONELY","LOOSE","LOVER",
  "LOWER","LOYAL","LUCID","LUNCH","MAGIC","MAJOR","MAKER","MANOR","MARCH","MATCH",
  "MAYOR","MEDIA","MERCY","MERIT","METAL","METER","MIGHT","MINOR","MINUS","MODEL",
  "MONEY","MONTH","MORAL","MOTOR","MOUNT","MOUSE","MOUTH","MOVIE","MUSIC","NAIVE",
  "NERVE","NEVER","NIGHT","NOBLE","NOISE","NORTH","NOTED","NOVEL","NURSE","OCCUR",
  "OCEAN","OFFER","OFTEN","ORDER","OTHER","OUGHT","OUTER","OWNER","OXIDE","PAINT",
  "PANEL","PANIC","PAPER","PARTY","PATCH","PAUSE","PEACE","PEACH","PEARL","PENNY",
  "PHASE","PHONE","PHOTO","PIANO","PIECE","PILOT","PITCH","PIXEL","PLACE","PLAIN",
  "PLANE","PLANT","PLATE","PLAZA","PLEAD","PLUMB","PLUME","POINT","POLAR","POUND",
  "POWER","PRESS","PRICE","PRIDE","PRIME","PRINCE","PRINT","PRIOR","PRIZE","PROBE",
  "PROOF","PROUD","PROVE","PSALM","PULSE","PUNCH","PUPIL","QUEEN","QUERY","QUEST",
  "QUEUE","QUICK","QUIET","QUITE","QUOTA","QUOTE","RADAR","RADIO","RAISE","RANGE",
  "RAPID","RATIO","REACH","REACT","READY","REALM","REBEL","REFER","REIGN","RELAX",
  "REPLY","RIGHT","RIGID","RISKY","RIVAL","RIVER","ROBIN","ROBOT","ROCKY","ROGER",
  "ROMAN","ROUGH","ROUND","ROUTE","ROYAL","RUGBY","RULER","RURAL","SADLY","SAINT",
  "SALAD","SAUCE","SCALE","SCARE","SCENE","SCOPE","SCORE","SENSE","SERVE","SEVEN",
  "SHALL","SHAME","SHAPE","SHARE","SHARK","SHARP","SHEER","SHEET","SHELF","SHELL",
  "SHIFT","SHINE","SHIRT","SHOCK","SHOOT","SHORT","SHOUT","SIGHT","SINCE","SIXTH",
  "SIXTY","SIZED","SKILL","SLATE","SLEEP","SLICE","SLIDE","SLOPE","SMALL","SMART",
  "SMELL","SMILE","SMOKE","SNAKE","SOLAR","SOLID","SOLVE","SORRY","SOUND","SOUTH",
  "SPACE","SPARE","SPEAK","SPEED","SPEND","SPENT","SPICE","SPINE","SPLIT","SPOKE",
  "SPORT","SPRAY","SQUAD","STACK","STAFF","STAGE","STAIN","STAKE","STALE","STALL",
  "STAMP","STAND","STARE","START","STATE","STAYS","STEAL","STEAM","STEEL","STEEP",
  "STEER","STERN","STICK","STIFF","STILL","STOCK","STONE","STOOD","STORE","STORM",
  "STORY","STOVE","STRAP","STRAW","STRIP","STUCK","STUDY","STUFF","STYLE","SUGAR",
  "SUITE","SUPER","SURGE","SWAMP","SWEAR","SWEEP","SWEET","SWEPT","SWIFT","SWING",
  "SWORD","SWORE","SWORN","TABLE","TASTE","TEACH","TEETH","TEMPO","TENSE","TENTH",
  "THEME","THERE","THICK","THIEF","THING","THINK","THIRD","THOSE","THREE","THREW",
  "THROW","THUMB","TIDAL","TIGHT","TIMER","TIRED","TITLE","TODAY","TOKEN","TOTAL",
  "TOUCH","TOUGH","TOWEL","TOWER","TOXIC","TRACE","TRACK","TRADE","TRAIL","TRAIN",
  "TRAIT","TRASH","TREAT","TREND","TRIAL","TRIBE","TRICK","TRIED","TROOP","TRUCK",
  "TRULY","TRUMP","TRUNK","TRUST","TRUTH","TUMOR","TWICE","TWIST","ULTRA","UNCLE",
  "UNDER","UNION","UNITE","UNITY","UNTIL","UPPER","UPSET","URBAN","USAGE","USUAL",
  "UTTER","VALID","VALUE","VALVE","VIDEO","VIGOR","VIRAL","VIRUS","VISIT","VITAL",
  "VIVID","VOCAL","VOICE","VOTER","WAGES","WASTE","WATCH","WATER","WEARY","WEIGH",
  "WEIRD","WHEAT","WHEEL","WHERE","WHICH","WHILE","WHITE","WHOLE","WHOSE","WIDER",
  "WOMAN","WORLD","WORRY","WORSE","WORST","WORTH","WOULD","WOUND","WRITE","WRONG",
  "WROTE","YIELD","YOUNG","YOUTH",
  // Add all wordle pool words too
  ...wordlePool
]);

// ======================== MODAL OVERLAY ========================
function GameModal({ title, icon, onClose, children }) {
  return ReactDOM.createPortal(
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.6)', zIndex: 9999,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '20px'
    }} onClick={onClose}>
      <div style={{
        background: 'white', borderRadius: '16px', maxWidth: '500px', width: '100%',
        maxHeight: '90vh', overflow: 'hidden', display: 'flex', flexDirection: 'column',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }} onClick={e => e.stopPropagation()}>
        {/* Modal Header */}
        <div style={{
          background: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)',
          padding: '16px 20px', color: 'white', display: 'flex', alignItems: 'center',
          justifyContent: 'space-between', flexShrink: 0
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span style={{ fontSize: '24px' }}>{icon}</span>
            <h3 style={{ margin: 0, fontSize: '20px' }}>{title}</h3>
          </div>
          <button onClick={onClose} style={{
            background: 'rgba(255,255,255,0.2)', border: 'none', color: 'white',
            width: '32px', height: '32px', borderRadius: '50%', cursor: 'pointer',
            fontSize: '18px', display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}>✕</button>
        </div>
        {/* Modal Body */}
        <div style={{ padding: '20px', overflowY: 'auto', flex: 1 }}>
          {children}
        </div>
        {/* Footer note */}
        <div style={{
          padding: '8px 16px', background: '#f0f9ff', borderTop: '1px solid #e5e7eb',
          fontSize: '11px', color: '#4338ca', textAlign: 'center', lineHeight: '1.4',
          flexShrink: 0
        }}>
          🧪 Research shows short brain breaks with puzzles and word games improve focus, memory retention, and problem-solving skills.
        </div>
      </div>
    </div>,
    document.body
  );
}

// ======================== QUIZ GAME (One question at a time) ========================
function QuizGame({ dayIndex }) {
  const quiz = quizPool[dayIndex % quizPool.length];
  const [answers, setAnswers] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [currentQ, setCurrentQ] = useState(0);

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem('dc_quiz') || '{}');
    if (saved.date === new Date().toDateString()) {
      if (saved.answers) setAnswers(saved.answers);
      if (saved.submitted) setSubmitted(true);
    }
  }, []);

  const save = (a, s) => {
    localStorage.setItem('dc_quiz', JSON.stringify({
      date: new Date().toDateString(), answers: a, submitted: s
    }));
  };

  const select = (qi, oi) => {
    if (submitted) return;
    const updated = { ...answers, [qi]: oi };
    setAnswers(updated);
    save(updated, false);
  };

  const submit = () => { setSubmitted(true); save(answers, true); };
  const score = quiz.questions.reduce((s, q, i) => s + (answers[i] === q.a ? 1 : 0), 0);
  const total = quiz.questions.length;
  const q = quiz.questions[currentQ];

  return (
    <div>
      {/* Progress indicator */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
        <p style={{ fontSize: '14px', color: '#6b7280', margin: 0 }}>
          Question {currentQ + 1} of {total}
        </p>
        <div style={{ display: 'flex', gap: '6px' }}>
          {quiz.questions.map((_, i) => (
            <div key={i} style={{
              width: '10px', height: '10px', borderRadius: '50%',
              background: submitted
                ? (answers[i] === quiz.questions[i].a ? '#10b981' : '#ef4444')
                : (answers[i] !== undefined ? '#4f46e5' : '#d1d5db'),
              cursor: 'pointer', transition: 'all 0.2s',
              border: i === currentQ ? '2px solid #1f2937' : '2px solid transparent'
            }} onClick={() => setCurrentQ(i)} />
          ))}
        </div>
      </div>

      {/* Single question */}
      <div style={{ marginBottom: '20px' }}>
        <p style={{ fontSize: '16px', fontWeight: '600', color: '#1f2937', marginBottom: '14px' }}>
          {currentQ + 1}. {q.q}
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {q.opts.map((opt, oi) => {
            let bg = 'white', border = '1px solid #d1d5db', color = '#333';
            if (submitted) {
              if (oi === q.a) { bg = '#d1fae5'; border = '2px solid #10b981'; color = '#065f46'; }
              else if (answers[currentQ] === oi) { bg = '#fee2e2'; border = '2px solid #ef4444'; color = '#991b1b'; }
            } else if (answers[currentQ] === oi) {
              bg = '#eef2ff'; border = '2px solid #4f46e5'; color = '#4f46e5';
            }
            return (
              <button key={oi} onClick={() => select(currentQ, oi)} style={{
                padding: '12px 16px', background: bg, border, borderRadius: '8px',
                cursor: submitted ? 'default' : 'pointer', textAlign: 'left',
                fontSize: '15px', color, fontWeight: answers[currentQ] === oi ? '600' : '400',
                transition: 'all 0.15s'
              }}>{opt}</button>
            );
          })}
        </div>
      </div>

      {/* Navigation buttons */}
      <div style={{ display: 'flex', gap: '10px', marginBottom: '16px' }}>
        {currentQ > 0 && (
          <button onClick={() => setCurrentQ(currentQ - 1)} style={{
            flex: 1, padding: '10px', background: '#f3f4f6', color: '#374151',
            border: '1px solid #d1d5db', borderRadius: '8px', fontWeight: '600',
            cursor: 'pointer', fontSize: '14px'
          }}>← Previous</button>
        )}
        {currentQ < total - 1 && (
          <button onClick={() => setCurrentQ(currentQ + 1)} style={{
            flex: 1, padding: '10px', background: '#eef2ff', color: '#4f46e5',
            border: '1px solid #c7d2fe', borderRadius: '8px', fontWeight: '600',
            cursor: 'pointer', fontSize: '14px'
          }}>Next →</button>
        )}
      </div>

      {/* Submit / Result */}
      {!submitted ? (
        <button onClick={submit} disabled={Object.keys(answers).length < total} style={{
          width: '100%', padding: '12px', background: Object.keys(answers).length < total ? '#d1d5db' : '#4f46e5',
          color: 'white', border: 'none', borderRadius: '8px', fontWeight: '600',
          cursor: Object.keys(answers).length < total ? 'not-allowed' : 'pointer', fontSize: '15px'
        }}>Check Answers ({Object.keys(answers).length}/{total} answered)</button>
      ) : (
        <div style={{
          textAlign: 'center', padding: '14px', borderRadius: '8px',
          background: score === total ? '#d1fae5' : score >= 2 ? '#fef3c7' : '#fee2e2',
          color: score === total ? '#065f46' : score >= 2 ? '#92400e' : '#991b1b',
          fontWeight: '600', fontSize: '16px'
        }}>
          {score === total ? `🎉 Perfect! ${score}/${total}` : score >= 2 ? `👍 Great! ${score}/${total}` : score === 1 ? `💪 ${score}/${total} — Keep practicing!` : `📚 ${score}/${total} — Try again tomorrow!`}
        </div>
      )}
    </div>
  );
}

// ======================== WORD GAME ========================
function WordGame({ dayIndex }) {
  const word = wordPool[dayIndex % wordPool.length];
  const [showHint, setShowHint] = useState(false);
  return (
    <div>
      <div style={{ textAlign: 'center', marginBottom: '24px' }}>
        <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#4f46e5', marginBottom: '4px', letterSpacing: '1px' }}>
          {word.word}
        </div>
        <div style={{ fontSize: '14px', color: '#6b7280', fontStyle: 'italic' }}>Word of the Day</div>
      </div>
      <div style={{ background: '#f0f9ff', padding: '16px', borderRadius: '10px', marginBottom: '14px' }}>
        <div style={{ fontSize: '12px', color: '#4f46e5', fontWeight: '600', marginBottom: '6px' }}>DEFINITION</div>
        <p style={{ fontSize: '16px', color: '#1f2937', margin: 0, lineHeight: '1.5' }}>{word.def}</p>
      </div>
      <div style={{ background: '#f9fafb', padding: '16px', borderRadius: '10px', marginBottom: '14px', borderLeft: '4px solid #10b981' }}>
        <div style={{ fontSize: '12px', color: '#10b981', fontWeight: '600', marginBottom: '6px' }}>EXAMPLE</div>
        <p style={{ fontSize: '15px', color: '#374151', margin: 0, fontStyle: 'italic', lineHeight: '1.5' }}>"{word.example}"</p>
      </div>
      <button onClick={() => setShowHint(!showHint)} style={{
        width: '100%', padding: '12px', background: showHint ? '#fef3c7' : '#f3f4f6',
        border: '1px solid #e5e7eb', borderRadius: '8px', cursor: 'pointer',
        fontSize: '14px', color: '#374151', fontWeight: '500'
      }}>
        {showHint ? `💡 ${word.hint}` : '💡 Show Memory Hint'}
      </button>
      <div style={{
        marginTop: '16px', padding: '14px', background: '#eef2ff', borderRadius: '10px',
        fontSize: '14px', color: '#4338ca', textAlign: 'center'
      }}>
        ✏️ Challenge: Try using "<strong>{word.word.toLowerCase()}</strong>" in a sentence today!
      </div>
    </div>
  );
}

// ======================== BRAIN TEASER GAME ========================
function TeaserGame({ dayIndex }) {
  const teaser = teaserPool[dayIndex % teaserPool.length];
  const [userAnswer, setUserAnswer] = useState('');
  const [showHint, setShowHint] = useState(false);
  const [showAnswer, setShowAnswer] = useState(false);
  const [checked, setChecked] = useState(false);
  const [isCorrect, setIsCorrect] = useState(false);

  const checkAnswer = () => {
    const clean = (s) => s.toLowerCase().replace(/[^a-z0-9]/g, '');
    const userClean = clean(userAnswer);
    const answerClean = clean(teaser.answer);
    // Check if user's answer contains the key part of the answer
    const correct = userClean.includes(answerClean) || answerClean.includes(userClean);
    setIsCorrect(correct);
    setChecked(true);
  };

  return (
    <div>
      <div style={{
        background: '#faf5ff', padding: '24px', borderRadius: '12px',
        border: '2px solid #e9d5ff', marginBottom: '20px'
      }}>
        <p style={{ fontSize: '16px', color: '#1f2937', lineHeight: '1.7', margin: 0, fontWeight: '500' }}>
          {teaser.puzzle}
        </p>
      </div>

      {/* Answer input */}
      {!showAnswer && (
        <div style={{ marginBottom: '16px' }}>
          <div style={{ display: 'flex', gap: '8px' }}>
            <input
              type="text"
              value={userAnswer}
              onChange={(e) => { setUserAnswer(e.target.value); setChecked(false); }}
              onKeyDown={(e) => e.key === 'Enter' && userAnswer.trim() && checkAnswer()}
              placeholder="Type your answer..."
              style={{
                flex: 1, padding: '12px', border: '2px solid #d1d5db', borderRadius: '8px',
                fontSize: '15px'
              }}
            />
            <button onClick={checkAnswer} disabled={!userAnswer.trim()} style={{
              padding: '12px 20px', background: userAnswer.trim() ? '#4f46e5' : '#d1d5db',
              color: 'white', border: 'none', borderRadius: '8px', fontWeight: '600',
              cursor: userAnswer.trim() ? 'pointer' : 'not-allowed', fontSize: '14px'
            }}>Check</button>
          </div>
          {checked && (
            <div style={{
              marginTop: '10px', padding: '10px', borderRadius: '8px', fontSize: '14px', fontWeight: '600',
              background: isCorrect ? '#d1fae5' : '#fef3c7',
              color: isCorrect ? '#065f46' : '#92400e', textAlign: 'center'
            }}>
              {isCorrect ? '🎉 Correct! Well done!' : '🤔 Not quite — try again or check the answer below!'}
            </div>
          )}
        </div>
      )}

      <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
        <button onClick={() => setShowHint(!showHint)} style={{
          flex: 1, padding: '10px', background: showHint ? '#fef3c7' : '#f3f4f6',
          border: '1px solid #e5e7eb', borderRadius: '8px', cursor: 'pointer',
          fontSize: '13px', fontWeight: '500'
        }}>
          {showHint ? '🔍 Hint shown' : '🔍 Need a hint?'}
        </button>
        <button onClick={() => setShowAnswer(!showAnswer)} style={{
          flex: 1, padding: '10px', background: showAnswer ? '#d1fae5' : '#f3f4f6',
          border: '1px solid #e5e7eb', borderRadius: '8px', cursor: 'pointer',
          fontSize: '13px', fontWeight: '500'
        }}>
          {showAnswer ? '✅ Answer shown' : '👀 Show Answer'}
        </button>
      </div>
      {showHint && (
        <div style={{ padding: '12px', background: '#fef3c7', borderRadius: '8px', marginBottom: '8px', fontSize: '14px', color: '#92400e' }}>
          💡 {teaser.hint}
        </div>
      )}
      {showAnswer && (
        <div style={{ padding: '14px', background: '#d1fae5', borderRadius: '8px', fontSize: '16px', color: '#065f46', fontWeight: '600', textAlign: 'center' }}>
          🎯 {teaser.answer}
        </div>
      )}
    </div>
  );
}

// ======================== WORDLE GAME ========================
function WordleGame({ dayIndex }) {
  const answer = wordlePool[dayIndex % wordlePool.length];
  const [guesses, setGuesses] = useState([]);
  const [input, setInput] = useState('');
  const [won, setWon] = useState(false);
  const [lost, setLost] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem('dc_wordle') || '{}');
    if (saved.date === new Date().toDateString() && saved.guesses) {
      setGuesses(saved.guesses);
      if (saved.guesses.includes(answer)) setWon(true);
      else if (saved.guesses.length >= 6) setLost(true);
    }
  }, [answer]);

  const save = (g) => {
    localStorage.setItem('dc_wordle', JSON.stringify({ date: new Date().toDateString(), guesses: g }));
  };

  const guess = () => {
    const g = input.toUpperCase().trim();
    if (g.length !== 5) return;
    if (!validWords.has(g)) {
      setError('Not a valid word! Try another.');
      setTimeout(() => setError(''), 2000);
      return;
    }
    const updated = [...guesses, g];
    setGuesses(updated);
    setInput('');
    setError('');
    if (g === answer) setWon(true);
    else if (updated.length >= 6) setLost(true);
    save(updated);
  };

  const getColor = (letter, index, g) => {
    if (g[index] === answer[index]) return '#6aaa64';
    if (answer.includes(letter)) return '#c9b458';
    return '#787c7e';
  };

  return (
    <div>
      <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '16px' }}>Guess the 5-letter academic word in 6 tries.</p>

      {/* Grid */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginBottom: '16px', alignItems: 'center' }}>
        {[...Array(6)].map((_, ri) => {
          const g = guesses[ri] || '';
          return (
            <div key={ri} style={{ display: 'flex', gap: '5px' }}>
              {[...Array(5)].map((_, ci) => {
                const letter = g[ci] || '';
                return (
                  <div key={ci} style={{
                    width: '48px', height: '48px', display: 'flex', alignItems: 'center',
                    justifyContent: 'center', fontSize: '20px', fontWeight: 'bold',
                    background: g ? getColor(letter, ci, g) : '#fff',
                    color: g ? 'white' : '#333',
                    border: g ? 'none' : '2px solid #d1d5db', borderRadius: '6px'
                  }}>{letter}</div>
                );
              })}
            </div>
          );
        })}
      </div>

      {/* Error */}
      {error && (
        <div style={{ textAlign: 'center', color: '#ef4444', fontSize: '14px', fontWeight: '600', marginBottom: '10px' }}>
          ❌ {error}
        </div>
      )}

      {/* Input */}
      {!won && !lost && (
        <div style={{ display: 'flex', gap: '8px' }}>
          <input type="text" value={input}
            onChange={(e) => setInput(e.target.value.replace(/[^a-zA-Z]/g, '').slice(0, 5))}
            onKeyDown={(e) => e.key === 'Enter' && guess()}
            placeholder="Type 5 letters..."
            maxLength={5}
            style={{
              flex: 1, padding: '12px', border: '2px solid #d1d5db', borderRadius: '8px',
              fontSize: '18px', textTransform: 'uppercase', letterSpacing: '4px',
              textAlign: 'center', fontWeight: 'bold'
            }}
          />
          <button onClick={guess} disabled={input.length !== 5} style={{
            padding: '12px 20px', background: input.length === 5 ? '#4f46e5' : '#d1d5db',
            color: 'white', border: 'none', borderRadius: '8px', fontWeight: '600',
            cursor: input.length === 5 ? 'pointer' : 'not-allowed', fontSize: '15px'
          }}>Go</button>
        </div>
      )}

      {/* Legend */}
      <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', marginTop: '14px', fontSize: '12px', color: '#6b7280' }}>
        <span><span style={{ display: 'inline-block', width: '14px', height: '14px', background: '#6aaa64', borderRadius: '3px', verticalAlign: 'middle', marginRight: '4px' }}></span>Correct</span>
        <span><span style={{ display: 'inline-block', width: '14px', height: '14px', background: '#c9b458', borderRadius: '3px', verticalAlign: 'middle', marginRight: '4px' }}></span>Wrong spot</span>
        <span><span style={{ display: 'inline-block', width: '14px', height: '14px', background: '#787c7e', borderRadius: '3px', verticalAlign: 'middle', marginRight: '4px' }}></span>Not in word</span>
      </div>

      {won && (
        <div style={{ marginTop: '14px', padding: '14px', background: '#d1fae5', borderRadius: '10px', textAlign: 'center', fontSize: '16px', color: '#065f46', fontWeight: '600' }}>
          🎉 Brilliant! You got it in {guesses.length} {guesses.length === 1 ? 'try' : 'tries'}!
        </div>
      )}
      {lost && (
        <div style={{ marginTop: '14px', padding: '14px', background: '#fee2e2', borderRadius: '10px', textAlign: 'center', fontSize: '15px', color: '#991b1b' }}>
          The word was <strong>{answer}</strong>. Try again tomorrow! 💪
        </div>
      )}
    </div>
  );
}

// ======================== MAIN COMPONENT — 4 GAME CARDS ========================
function DailyChallenge() {
  const dayIndex = getDayOfYear();
  const [activeGame, setActiveGame] = useState(null);

  const today = new Date();
  const dateStr = today.toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short' });

  const games = [
    { id: 'quiz', icon: '🧠', title: 'Daily Quiz', subtitle: '3 quick questions', color: '#4f46e5', bg: '#eef2ff' },
    { id: 'word', icon: '📖', title: 'Word of the Day', subtitle: 'Build vocabulary', color: '#10b981', bg: '#ecfdf5' },
    { id: 'teaser', icon: '🧩', title: 'Brain Teaser', subtitle: 'Logic puzzle', color: '#f59e0b', bg: '#fef3c7' },
    { id: 'wordle', icon: '🟩', title: 'Wordle', subtitle: 'Guess the word', color: '#8b5cf6', bg: '#f5f3ff' }
  ];

  return (
    <>
      <div style={{ textAlign: 'center', marginBottom: '8px' }}>
        <h3 style={{ fontSize: '20px', color: '#4f46e5', margin: '0 0 4px 0' }}>🎯 Daily Challenges</h3>
        <p style={{ fontSize: '13px', color: '#6b7280', margin: 0 }}>{dateStr} — New activities every day</p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
        {games.map(game => (
          <div
            key={game.id}
            onClick={() => setActiveGame(game.id)}
            style={{
              background: game.bg, border: `2px solid ${game.color}22`, borderRadius: '12px',
              padding: '16px', cursor: 'pointer', textAlign: 'center',
              transition: 'all 0.2s'
            }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = `0 6px 16px ${game.color}25`; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}
          >
            <div style={{ fontSize: '32px', marginBottom: '6px' }}>{game.icon}</div>
            <div style={{ fontSize: '14px', fontWeight: '700', color: game.color, marginBottom: '2px' }}>{game.title}</div>
            <div style={{ fontSize: '11px', color: '#6b7280' }}>{game.subtitle}</div>
          </div>
        ))}
      </div>

      <div style={{ textAlign: 'center', marginTop: '10px', fontSize: '11px', color: '#9ca3af' }}>
        🧪 Short brain breaks improve focus & memory retention
      </div>

      {/* Game Modals */}
      {activeGame === 'quiz' && (
        <GameModal title="Daily Quiz" icon="🧠" onClose={() => setActiveGame(null)}>
          <QuizGame dayIndex={dayIndex} />
        </GameModal>
      )}
      {activeGame === 'word' && (
        <GameModal title="Word of the Day" icon="📖" onClose={() => setActiveGame(null)}>
          <WordGame dayIndex={dayIndex} />
        </GameModal>
      )}
      {activeGame === 'teaser' && (
        <GameModal title="Brain Teaser" icon="🧩" onClose={() => setActiveGame(null)}>
          <TeaserGame dayIndex={dayIndex} />
        </GameModal>
      )}
      {activeGame === 'wordle' && (
        <GameModal title="PrepSmart Wordle" icon="🟩" onClose={() => setActiveGame(null)}>
          <WordleGame dayIndex={dayIndex} />
        </GameModal>
      )}
    </>
  );
}

export default DailyChallenge;
